var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_c('NavApp',{attrs:{"title":_vm.pageTitle}}),_c('div',{staticClass:"my-salon app-content"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }